import { render } from "./SoFSoWPosterDownload.vue?vue&type=template&id=1804edbc&scoped=true"
import script from "./SoFSoWPosterDownload.vue?vue&type=script&lang=js"
export * from "./SoFSoWPosterDownload.vue?vue&type=script&lang=js"

import "./SoFSoWPosterDownload.vue?vue&type=style&index=0&id=1804edbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1804edbc"]])

export default __exports__